import { Stack, Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface BlueLightDialogProps extends HelpDialogLayoutProps {}
export default function BlueLightDialog(props: BlueLightDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "起床から14～15時間後に睡眠ホルモンと呼ばれるメラトニンが分泌されます。",
              "しかし、スマホ・テレビ・PCなどから発光されるブルーライトを浴びると、メラトニン分泌が抑制され、眠気を感じにくくなってしまいます。",
              "また、SNSやゲーム、仕事など覚醒度の高いコンテンツが脳の覚醒を強く促し、寝付きを悪くしてしまったり、眠りを浅くしてしまったりすることが指摘されています。さらに、通知音や着信が睡眠中の覚醒を促し、睡眠の質を低下させる原因にもなります。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">
            スマホ・電子機器の適切な利用方法
          </Typography>
          <ContentStack>
            <Stack>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "underline",
                }}
              >
                就寝1時間前および寝室での使用：できるだけ避ける
              </Typography>
              <ContentStack>
                <BodyTypographies
                  contents={[
                    "「寝る前のスマホ、やめたほうがいいのはわかってるけど、つい触っちゃう…」という方も多いのではないでしょうか。スマホやPCの使用を控えることで、睡眠の質が向上し、日中のパフォーマンス改善や気分の安定にもつながることが観察されています。",
                  ]}
                />
                <BodyTypographies
                  contents={[
                    "理想的には、就寝30分～1時間前にはスマホの使用を控え、寝室での使用も避けるのが望ましいですが、いきなりゼロにするのが難しい場合は、まず刺激の少ないコンテンツ（映画や親しい人とのメッセージなど）に限定することから始めてみましょう。",
                  ]}
                />
                <BodyTypographies
                  contents={[
                    "「スマホを目覚まし代わりに使っている」「寝る前にやることがないから仕方なくスマホを触っている」という場合は、目覚ましにはアナログ時計やウェアラブルデバイスの振動アラームを使う、読書は紙の本にする、寝室では照明を落としてラジオを聞くなど、スマホなしで済む工夫を少しずつ取り入れてみてください。",
                  ]}
                />
              </ContentStack>
            </Stack>
            <Stack>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "underline",
                }}
              >
                寝床での使用：絶対に避ける
              </Typography>
              <ContentStack>
                <BodyTypographies
                  contents={[
                    "「スマホを持ち込むとダメなのはわかってるけど、つい…」という気持ち、よくわかります。しかし、寝る直前までスマホを使っていたとしても、寝床に入ったら手放す習慣をつけていきましょう。",
                    "スマホを寝床に持ち込むと、無意識のうちに画面を見てしまい、寝付きが悪くなったり、眠りが浅くなったりすることが多くの研究で指摘されています。また、夜中に目が覚めた時、何気なく時間を確認するつもりでスマホを見てしまい、そのまま目が冴えてしまったという経験はありませんか？これを防ぐためにも、寝床に入る時にはスマホを遠ざけ、睡眠環境を最優先に整えましょう。",
                  ]}
                />
                <BodyTypographies
                  contents={[
                    "「いきなり全部やめるのは無理」という場合は、まずは寝床ではスマホを使わないことからスタートしてみてください。	",
                  ]}
                />
              </ContentStack>
            </Stack>
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
